"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typebox_1 = require("@sinclair/typebox");
exports.default = typebox_1.Type.Object({
    company_id: typebox_1.Type.Number(),
    company_name: typebox_1.Type.String(),
    facility_profile_id: typebox_1.Type.String(),
    address_formatted: typebox_1.Type.String(),
    existing_facility_returned: typebox_1.Type.Boolean(),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number())
});
